export default __webpack_public_path__ + "static/media/avatar3.79eef8fa.png";